import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import api from '../../api';
import ReactDataTable from '../components/ReactDataTable';
import { useGlobalContext } from '../../context';
import SideNav from '../components/SideNav';
import adminDashLinks from './adminDashLinks';

import { AiOutlineCheck } from "react-icons/ai";
import { BsTrash } from "react-icons/bs";
import { GiHamburgerMenu } from "react-icons/gi";
import { BiLogOut } from "react-icons/bi";
import ConfirmModal from '../components/ConfirmModal';

const AdminWithdrawals = () => {
  const { allUsersWithData } = useGlobalContext();
  const [navActive, updateNavActive] = useState(null);
  const [confirm, setConfirm] = useState(null);

  const askConfirm = (title, message, onConfirm, confirmLabel, confirmClass) => {
    setConfirm({ title, message, onConfirm, confirmLabel, confirmClass });
  };

  const clearSess = async () => {
    try { await api.post('/api/logout'); } catch (e) {}
    window.sessionStorage.clear();
  };

  const hideNav = () => updateNavActive(false);

  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [navActive]);

  const deleteWithdrawal = async (userId) => {
    try {
      const response = await api.delete('/api/admin/deletewithdrawal', { data: { userEmail: userId } });
      const responseData = response.data;
      if (responseData.errMsg) { toast.error(responseData.errMsg); }
      else { toast.success(responseData.successMsg); setTimeout(() => window.location.reload(), 5000); }
    } catch (error) { console.log(error); }
  };

  const confirmwithdrawal = async (userId) => {
    try {
      const response = await api.post('/api/admin/confirmwithdrawal', { userEmail: userId });
      const responseData = response.data;
      if (responseData.errMsg) { toast.error(responseData.errMsg); }
      else { toast.success(responseData.successMsg); setTimeout(() => window.location.reload(), 5000); }
    } catch (error) { console.log(error); }
  };

  const declineWithdrawal = async (userId, amount, email) => {
    try {
      const response = await api.post('/api/admin/declinewithdrawal', { userEmail: userId, amount, email });
      const responseData = response.data;
      if (responseData.errMsg) { toast.error(responseData.errMsg); }
      else { toast.success(responseData.successMsg); setTimeout(() => window.location.reload(), 5000); }
    } catch (error) { console.log(error); }
  };

  const columns = [
    {
      name: 'Date',
      selector: (row) => row.withdrawdate,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{new Date(row.withdrawdate).toLocaleDateString('en-GB')}</div>,
    },
    {
      name: 'Email',
      selector: row => row.withdrawemail,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.withdrawemail}</div>,
    },
    {
      name: 'Amount',
      selector: row => row.withdrawamount,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>${parseFloat(row.withdrawamount).toLocaleString()}</div>,
    },
    {
      name: 'Type',
      selector: row => row.withdrawtype,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.withdrawtype}</div>,
    },
    {
      name: 'Status',
      selector: row => row.withdrawstatus,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.withdrawstatus}</div>,
    },
    {
      name: 'Recipient',
      selector: row => row.receiverdetails,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.receiverdetails}</div>,
    },
    {
      name: 'Action',
      cell: (row) => (
        <div style={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button onClick={() => askConfirm('Delete Withdrawal', 'Delete this withdrawal record?', () => deleteWithdrawal(row._id))} className="bg-red-700 text-white flex justify-center items-center min-w-[32px] h-[28px] rounded-lg px-2"><BsTrash /></button>
          {row.withdrawstatus === 'Pending' && (
            <>
              <button onClick={() => askConfirm('Decline Withdrawal', `Decline withdrawal of $${parseFloat(row.withdrawamount).toLocaleString()} for ${row.withdrawemail}?`, () => declineWithdrawal(row._id, row.withdrawamount, row.withdrawemail), 'Decline', 'bg-red-500 hover:bg-red-600')} className="bg-red-400 text-white flex justify-center items-center min-w-[32px] h-[28px] rounded-lg px-2 text-[12px]">✕</button>
              <button onClick={() => askConfirm('Confirm Withdrawal', `Approve withdrawal of $${parseFloat(row.withdrawamount).toLocaleString()} for ${row.withdrawemail}?`, () => confirmwithdrawal(row._id), 'Approve', 'bg-green-700 hover:bg-green-800')} className="bg-green-700 text-white flex justify-center items-center min-w-[32px] h-[28px] rounded-lg px-2"><AiOutlineCheck /></button>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="absolute overflow-x-hidden w-full min-h-full text-white bg-black">
      <SideNav
        hideNav={hideNav}
        logout="/signin"
        logoutBtn={clearSess}
        translateAction={navActive ? `translate-x-[0px]` : `translate-x-[-500px]`}
        backgroundColor="bg-black"
        iconBorderColor="border-black"
        iconBgColor="bg-inherit"
        textColor="text-white"
        links={adminDashLinks}
        logouticon={
          <BiLogOut className="cursor-pointer text-[20px] text-white transition-all ease-in duration-300 hover:scale-[1.1]" />
        }
      />

      {navActive && (
        <div className="fixed inset-0 bg-black/60 z-40 xl:hidden" onClick={hideNav} />
      )}

      {confirm && (
        <ConfirmModal
          title={confirm.title}
          message={confirm.message}
          confirmLabel={confirm.confirmLabel}
          confirmClass={confirm.confirmClass}
          onConfirm={() => { confirm.onConfirm(); setConfirm(null); }}
          onCancel={() => setConfirm(null)}
        />
      )}

      <div className="relative flex flex-col flex-grow w-full h-full px-4 mb-[100px] xl:pl-[304px] xl:pr-6">
        {/* top nav */}
        <nav className="relative w-full min-h-[100px] flex justify-center items-start pt-3">
          <div className="relative w-full min-h-[50px] flex justify-between items-center xl:justify-end">
            <button onClick={() => updateNavActive(true)} className="relative xl:hidden">
              <GiHamburgerMenu className="text-[20px] text-[#A9ABAD]" />
            </button>
          </div>
        </nav>

        {/* page header */}
        <div className="relative w-full flex flex-col justify-start items-start space-y-1 pt-4 pb-8">
          <h3 className="text-[20px] font-[600] text-white">Manage Withdrawals</h3>
          <p className="text-[#A9ABAD] text-[14px]">Review and action user withdrawal requests.</p>
        </div>

        {/* table */}
        <div className="relative w-full overflow-x-auto">
          <ReactDataTable columns={columns} data={allUsersWithData} />
        </div>
      </div>
    </div>
  );
};

export default AdminWithdrawals;
